


















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "AiResponseConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    aiConfirmStatus: { type: Boolean, required: true },
    value: { type: Boolean, default: false },
  },
});
